export const translations = {
  eng: {
    // Header and main content
    mainTitle: "Cybersecurity Assessment Platform",
    mainDescription: "Comprehensive security assessment combining network discovery, vulnerability scanning, technology stack analysis, web security evaluation, infrastructure assessment, and data breach monitoring with AI-powered insights.",
    globalLanguageToggle: "Display entire website in Japanese",
    
    // Form section
    formTitle: "Security Assessment Request",
    formDescription: "Request a comprehensive cybersecurity assessment for your domain.",
    
    // Form fields
    languageLabel: "🌐 Language *",
    englishOption: "English",
    japaneseOption: "Japanese",
    firstNameLabel: "First Name *",
    lastNameLabel: "Last Name *",
    emailLabel: "Email Address *",
    emailDescription: "(Cyber Risk Report will be delivered to this email address)",
    domainLabel: "Domain to Assess *",
    domainPlaceholder: "example.com",
    domainDescription: "Enter just the domain (e.g., example.com). Your email domain must match.",
    termsAgreement: "I agree to the",
    termsOfService: "Terms of Service",
    termsAgreementEnd: "and understand that I may only assess domains I own or have explicit permission to scan.",
    
    // Form placeholders
    firstNamePlaceholder: "First Name",
    lastNamePlaceholder: "Last Name",
    emailPlaceholder: "Email Address",
    
    // Form validation messages
    firstNameRequired: "First name is required",
    lastNameRequired: "Last name is required",
    emailRequired: "Email is required",
    emailInvalid: "Invalid email format",
    domainRequired: "Domain is required",
    domainInvalid: "Invalid domain format (e.g., example.com)",
    emailDomainMismatch: "Email domain must match or be related to the assessment domain",
    termsRequired: "You must agree to the Terms of Service",
    emailDomainMatches: "Email domain matches target domain",
    emailDomainDoesNotMatch: "Email domain does not match target domain",
    
    // Status messages
    emailVerified: "Verified",
    emailNotVerified: "Not Verified",
    verified: "verified",
    unverified: "unverified",
    
    // Submit button text
    submitting: "Submitting...",
    startAssessment: "Start Security Assessment",
    startSecurityAssessment: "Start Security Assessment",
    verifyEmail: "Verify Email",
    initializePayment: "Initialize Payment",
    
    // Payment modal
    completePayment: "Complete Payment",
    pay: "Pay",
    
    // Plan selection
    selectPlan: "Select Your Plan",
    payNow: "💳 Pay Now",
    
    // Plan names and features (UI text only)
    planNames: {
      monthly: "Per Report",
      yearly: "Yearly Plan"
    },
    planFeatures: {
      monthly: ["Vulnerability scan", "Standard report", "Email support"],
      yearly: ["Monthly vulnerability scan", "Detailed report", "Priority support",]
    },
    
    // Modal texts
    requestAdditionalReport: "Request Additional Report",
    yourCurrentSubscription: "Your Current Subscription Status",
    subscriptionStatus: "SUBSCRIPTION STATUS",
    nextScheduled: "NEXT SCHEDULED",
    active: "Active",
    oneTimePayment: "One-time payment",
    immediateScanInitiation: "Immediate scan initiation",
    reportDeliveredWithin1Hour: "Report delivered within 1 hour",
    separateFromMonthlySchedule: "Separate from your monthly schedule",
    cancel: "Cancel",
    purchaseAdditionalReport: "Purchase Additional Report",
    
    // Additional popup texts
    reportGenerationTakingLonger: "Report Generation Taking Longer",
    reportGenerationMessage: "This is taking longer than expected. Your report will be sent to:",
    reportGenerationClose: "You can safely close this window. We will email you when your report is ready.",
    close: "Close",
    
    // Additional report popup
    additionalReportDescription: "Your monthly reports will continue to be delivered automatically on your scheduled date. This is a separate, immediate scan that allows you to get an updated report right now without affecting your regular monthly delivery schedule.",
    additionalReportFeatures: [
      "Immediate scan initiation",
      "Report delivered within 1 hour", 
      "Separate from your monthly schedule"
    ],
    
    // Notification modal
    notification: "Notification",
    
    // Success modal
    paymentSuccessful: "Payment Successful!",
    paymentSuccessMessage: "🎉 Payment successful! You can now begin your domain assessment. Let's secure that cyberspace! 🚀",
    continue: "Continue",
    
    // Domain report buttons and labels
    backToAssessment: "Back to Assessment",
    downloadFullReport: "Download Full Report",
    sslSecured: "SSL Secured",
    overallRiskScore: "Overall Risk Score",
    
    // Domain report section headers
    dnsRecords: "DNS RECORDS",
    sslCertificate: "SSL CERTIFICATE",
    openPorts: "OPEN PORTS",
    httpHeaders: "HTTP HEADERS",
    detectedTechnologiesVulnerabilities: "DETECTED TECHNOLOGIES & VULNERABILITIES",
    
    // Port status labels
    open: "open",
    closed: "Closed",
    openLabel: "Open",
    
    // DNS validation
    dnsValid: "DNS Valid",
    
    // Domain report labels
    domainRank: "Domain Rank",
    adultContent: "Adult Content",
    parking: "Parking",
    riskyTld: "Risky TLD",
    
    // Loading states
    verifyingToken: "Verifying your token...",
    reportGenerationLonger: "Report Generation Taking Longer",
    reportGenerationMessage: "This is taking longer than expected. Your report will be sent to:",
    reportGenerationClose: "You can safely close this window. We will email you when your report is ready.",
    
    // Footer
    poweredBy: "Powered by",
    
    // Logo alt text
    almataLogo: "Cyber Risk Report Logo",
    almataCybersecurity: "Almata Cybersecurity",
    
    // Error messages
    serverError: "server error",
    failedToFetchPlans: "Failed to fetch plans",
    incompletePlansData: "Incomplete plans data",
    failedToInitializePayment: "Failed to initialize payment",
    anErrorOccurred: "An error occurred",
    
    // Token verification
    emailVerifiedSuccess: "Your email has been verified successfully. Please click on the Button for Report Scan",
    invalidOrExpiredVerificationToken: "Invalid or expired verification token. Please request a new one.",
    noOemIdProvided: "You don't have any OEM partner to scan",
    invalidToken: "Invalid token",
    verificationEmailSent: "Verification email sent! Please check your inbox.",
    
    // Assessment messages
    assessmentStarted: "Assessment started!",
    monthlyPlanMessage: "You are currently subscribed to a 12-month Cyber Risk Protection Plan with Almata Global.Your detailed Cyber Risk Report will be automatically generated and delivered to your registered email address each cycle — no action required from your side.",
    yearlyPlanMessage: "12 month plan",
    requestAdditionalReportFlag: "Request Additional Report",
    
    // Backend response messages
    reportCompilationMessage: "The Cyber Risk Report is being compiled and will be sent to your registered email within 30 minutes",
    
    // Processing states
    processing: "Processing...",
    
    // Plan types
    monthlySubscriber: "Monthly Subscriber",
    annualSubscriber: "Annual Subscriber",
    
    // Subscription description
    subscriptionDescription: "You have an active {planType} subscription that includes {reportType} reports. Your next regularly scheduled report will be generated automatically on {date}.",
    monthlyReports: "12 monthly",
    regularReports: "regular",
    
    // Currency and payment
    usd: "USD",
    jpy: "JPY",
    usdLower: "usd",
    jpyLower: "jpy",
    
    // Time intervals
    monthly: "Monthly",
    annual: "Annual",
    oneTime: "One Time",
    year: "year",
    one_time: "one_time",
    
    // Plan types for comparison
    monthlySubscriberText: "Monthly Subscriber",
    annualSubscriberText: "Annual Subscriber",
    
    // Error messages for Stripe components
    failedToConfirmPayment: "Failed to confirm payment",
    errorConfirmingPayment: "Error confirming payment",
    errorDuringPayment: "An error occurred during payment",
    
    // Error messages
    failedToFetchPlans: "Failed to fetch plans",
    incompletePlansData: "Incomplete plans data",
    planDataIncomplete: "Plan data is incomplete",
    selectedPlanDataIncomplete: "Selected plan data is incomplete",
    invalidToken: "Invalid token",
    
    // Loading and status messages
    verifyingToken: "Verifying your token...",
    
    // Network status messages
    noInternetConnection: "No Internet Connection",
    offlineMessage: "You're offline. Please reconnect your internet and try again.",
    retryRefresh: "Retry (Refresh Page)",
    waitingForConnection: "Waiting for connection to come back...",
    offlineNote: "While offline, external scripts (like Stripe) may fail to load.",
    
    // Terms of Service
    cyberRiskReport: "External Cyber Risk Assessment Service",
    
    // Section 1: Overview
    overview: "Overview",
    overviewText1: "Our external cyber risk assessment report provides an automated, external assessment service designed to evaluate the publicly exposed digital footprint of a specified Fully Qualified Domain Name (FQDN).",
    overviewText2: "The Service delivers a structured cyber risk report based solely on publicly accessible data and external reconnaissance methodologies.",
    overviewText3: "The Service does not access internal systems, bypass authentication, or perform intrusive testing.",
    
    // Section 2: Diagnostic Target
    diagnosticTarget: "Diagnostic Target",
    singleDomainScope: "2.1 Single Domain Scope",
    diagnosticText1: "Each standard report covers:",
    diagnosticItem1: "One Fully Qualified Domain Name (FQDN)",
    diagnosticItem2: "External, internet-facing infrastructure associated with that domain",
    diagnosticText2: "The Service is:",
    diagnosticNotItem1: "Not limited to a single webpage or URL path",
    diagnosticNotItem2: "Not a web application penetration test",
    diagnosticNotItem3: "Not a vulnerability exploitation engagement",
    diagnosticNotItem4: "Not an internal network scan",
    diagnosticText3: "The assessment is domain-based and external in nature.",
    
    // Section 3: Subdomains
    subdomains: "Subdomains",
    subdomainsText1: "As part of the assessment process:",
    subdomainsItem1: "Publicly discoverable subdomains may be identified",
    subdomainsItem2: "Subdomains are listed for awareness and attack surface visibility",
    subdomainsText2: "However:",
    subdomainsNotItem1: "Each subdomain is not automatically scanned individually",
    subdomainsNotItem2: "A separate report is required for full assessment of each subdomain if deeper analysis is desired",
    subdomainsText3: "This approach allows predictable scope control and cost management.",
    
    // Section 4: Assessment Methodology
    assessmentMethodology: "Assessment Methodology",
    methodologyText1: "The Service may include automated evaluation of:",
    methodologyItem1: "DNS configuration",
    methodologyItem2: "Mail server security posture (SPF, DKIM, DMARC)",
    methodologyItem3: "SSL/TLS certificate validity and configuration",
    methodologyItem4: "Public breach exposure indicators",
    methodologyItem5: "Open port exposure (non-intrusive)",
    methodologyItem6: "Known vulnerability indicators from public databases",
    methodologyItem7: "Technology stack fingerprinting",
    methodologyItem8: "External configuration hygiene",
    methodologyItem9: "Public reputation signals",
    methodologyItem10: "Domain metadata and WHOIS data (where legally available)",
    methodologyText2: "The Service relies on passive and publicly available data sources.",
    methodologyText3: "No exploitation or authentication bypass techniques are used.",
    
    // Section 5: Risk Scoring
    riskScoring: "Risk Scoring",
    riskScoringText1: "Each report includes:",
    riskScoringItem1: "A structured risk score",
    riskScoringItem2: "Categorized findings",
    riskScoringItem3: "Severity indicators",
    riskScoringItem4: "Executive summary",
    riskScoringItem5: "Technical observations",
    riskScoringItem6: "Actionable recommendations",
    riskScoringText2: "Risk scores are generated using proprietary scoring logic and automated analysis models.",
    riskScoringText3: "The score is indicative and not a certification.",
    
    // Section 6: What the Service Does Not Include
    serviceNotInclude: "What the Service Does Not Include",
    notIncludeText1: "The Service does not include:",
    notIncludeItem1: "Penetration testing",
    notIncludeItem2: "Social engineering",
    notIncludeItem3: "Phishing simulation",
    notIncludeItem4: "Internal network scanning",
    notIncludeItem5: "Endpoint testing",
    notIncludeItem6: "Application-layer authenticated testing",
    notIncludeItem7: "Code review",
    notIncludeItem8: "Regulatory compliance certification",
    notIncludeItem9: "Legal opinion",
    notIncludeText2: "Additional services may require a separate agreement.",
    
    // Section 7: Data Sources
    dataSources: "Data Sources",
    dataSourcesText1: "The Service may utilize:",
    dataSourcesItem1: "Publicly accessible internet data",
    dataSourcesItem2: "Open-source intelligence (OSINT)",
    dataSourcesItem3: "Public vulnerability databases",
    dataSourcesItem4: "Public breach datasets",
    dataSourcesItem5: "Certificate transparency logs",
    dataSourcesItem6: "DNS and mail configuration records",
    dataSourcesText2: "Accuracy depends on the availability and reliability of these sources.",
    
    // Section 8: Deliverables
    deliverables: "Deliverables",
    deliverablesText1: "The standard deliverable includes:",
    deliverablesItem1: "A downloadable PDF cyber risk report",
    deliverablesItem2: "Executive-level summary",
    deliverablesItem3: "Technical findings",
    deliverablesItem4: "Recommended remediation steps",
    deliverablesText2: "Depending on subscription tier, the Service may also include:",
    deliverablesItem5: "Historical tracking",
    deliverablesItem6: "Monthly monitoring",
    deliverablesItem7: "Risk trend visualization",
    deliverablesItem8: "License-key-based report access",
    deliverablesItem9: "Domain re-scans",
    
    // Section 9: Customer Responsibilities
    customerResponsibilities: "Customer Responsibilities",
    customerRespText1: "The customer is responsible for:",
    customerRespItem1: "Ensuring authorization to assess the submitted domain",
    customerRespItem2: "Reviewing findings",
    customerRespItem3: "Implementing recommended remediation actions",
    customerRespItem4: "Maintaining their own cybersecurity program",
    customerRespText2: "The Service is advisory in nature.",
    
    // Section 10: Service Limitations
    serviceLimitations: "Service Limitations",
    limitationsText1: "Because the assessment is external and non-intrusive:",
    limitationsItem1: "Some vulnerabilities may not be detectable",
    limitationsItem2: "Results may change over time",
    limitationsItem3: "Newly discovered vulnerabilities may not appear immediately",
    limitationsItem4: "Public data sources may contain inaccuracies",
    limitationsText2: "The Service provides a snapshot of externally visible risk at the time of analysis.",
    
    // Section 11: Service Availability
    serviceAvailability: "Service Availability",
    availabilityText1: "The Service is provided on an automated, best-effort basis.",
    availabilityText2: "We do not guarantee:",
    availabilityItem1: "Continuous availability",
    availabilityItem2: "Real-time threat detection",
    availabilityItem3: "Instant report generation in all cases",
    availabilityText3: "Maintenance windows may occur.",
    
    // Domain Report
    noDataReceived: "No data received from API",
    failedToLoadReport: "Failed to load report data",
    reportPdf: "report.pdf",
    loading: "Loading...",
    loadingSecurityReport: "Loading security report...",
    backToHome: "Back to Home",
    domainSecurityReport: "Domain Security Report",
    noSummaryAvailable: "No summary available.",
    domain: "Domain",
    ipAddress: "IP Address",
    networkPerformance: "Network Performance",
    server: "Server",
    rootDomain: "Root Domain",
    city: "City",
    region: "Region",
    country: "Country",
    countryCode: "Country Code",
    isp: "ISP (Internet Service Provider)",
    latitude: "Latitude",
    longitude: "Longitude",
    timezone: "Timezone",
    zip: "ZIP",
    dnssec: "DNSSEC",
    registrar: "Registrar",
    registrarUrl: "Registrar URL",
    signed: "signed",
    unsigned: "unsigned",
    na: "N/A",
    
    // Additional Domain Report fields
    registrantCountry: "Registrant Country",
    registrantStateProvince: "Registrant State/Province",
    registrantEmail: "Registrant Email",
    nameServers: "Name Servers",
    registrarAbuseContact: "Registrar Abuse Contact",
    registrarWhoisServer: "Registrar WHOIS Server",
    
    // Coupon functionality
    couponCode: "Coupon Code",
    couponCodePlaceholder: "Enter coupon code",
    applyCoupon: "Apply Coupon",
    couponApplied: "Coupon applied successfully!",
    couponInvalid: "Invalid coupon code",
    couponInvalidForPlan: "Coupon is not valid for this plan",
    couponExpired: "Coupon has expired",
    couponAlreadyUsed: "Coupon already used",
    discountApplied: "Discount applied",
    originalPrice: "Original Price",
    discountedPrice: "Discounted Price",
    removeCoupon: "Remove Coupon",
    
    // Additional status messages and labels
    success: "Success!",
    errorLoadingReport: "Error loading report",
    noReportDataAvailable: "No report data available",
    expired: "Expired",
    unknown: "Unknown",
    listed: "Listed",
    clean: "Clean",
    present: "Present",
    notPresent: "Not Present",
    detected: "Detected",
    notDetected: "Not Detected",
    highRisk: "High Risk",
    lowRisk: "Low Risk",
    valid: "Valid",
    invalid: "Invalid",
    none: "None",
    yes: "Yes",
    no: "No",
    scanId: "Scan ID",
    noBreachesFound: "No Breaches Found",
    switchToEnglish: "Switch to English",
    switchToJapanese: "Switch to Japanese",
    breachDetected: "Breach Detected",
    pleaseSubmitDomainFirst: "Please submit a domain for assessment first",
    packetLoss: "Packet Loss",
    rtt: "RTT",
    exploitability: "Exploitability",
    impact: "Impact",
    baseScore: "Base Score",
    copyrightText: "All rights reserved."
  },
  
  ja: {
    // Header and main content
    mainTitle: "サイバーセキュリティ評価プラットフォーム",
    mainDescription: "ネットワーク発見、脆弱性スキャン、技術スタック分析、ウェブセキュリティ評価、インフラストラクチャ評価、AI駆動の洞察によるデータ侵害監視を組み合わせた包括的なセキュリティ評価。",
    globalLanguageToggle: "ウェブサイト全体を日本語で表示",
    
    // Form section
    formTitle: "セキュリティ評価リクエスト",
    formDescription: "ドメインの包括的なサイバーセキュリティ評価をリクエストしてください。",
    
    // Form fields
    languageLabel: "🌐 言語 *",
    englishOption: "English",
    japaneseOption: "Japanese",
    firstNameLabel: "名 *",
    lastNameLabel: "姓 *",
    emailLabel: "メールアドレス *",
    emailDescription: "(サイバーリスクレポートはこのメールアドレスに配信されます)",
    domainLabel: "評価対象ドメイン *",
    domainPlaceholder: "example.com",
    domainDescription: "ドメインのみを入力してください（例：example.com）。メールドメインと一致する必要があります。",
    termsAgreement: "利用規約に同意し、",
    termsOfService: "利用規約",
    termsAgreementEnd: "所有するドメインまたは明示的なスキャン許可を持つドメインのみを評価することを理解します。",
    
    // Form placeholders
    firstNamePlaceholder: "名",
    lastNamePlaceholder: "姓",
    emailPlaceholder: "メールアドレス",
    
    // Form validation messages
    firstNameRequired: "名は必須です",
    lastNameRequired: "姓は必須です",
    emailRequired: "メールアドレスは必須です",
    emailInvalid: "無効なメール形式です",
    domainRequired: "ドメインは必須です",
    domainInvalid: "無効なドメイン形式です（例：example.com）",
    emailDomainMismatch: "メールドメインは評価対象ドメインと一致または関連している必要があります",
    termsRequired: "利用規約に同意する必要があります",
    emailDomainMatches: "メールドメインがターゲットドメインと一致します",
    emailDomainDoesNotMatch: "メールドメインがターゲットドメインと一致しません",
    
    // Status messages
    emailVerified: "認証済み",
    emailNotVerified: "未認証",
    verified: "verified",
    unverified: "unverified",
    
    // Submit button text
    submitting: "送信中...",
    startAssessment: "セキュリティ評価を開始",
    startSecurityAssessment: "セキュリティ評価を開始",
    verifyEmail: "メールを認証",
    initializePayment: "支払いを初期化",
    
    // Payment modal
    completePayment: "支払いを完了",
    pay: "支払う",
    
    // Plan selection
    selectPlan: "プランを選択してください",
    payNow: "💳 今すぐ支払う",
    
    // Plan names and features (UI text only)
    planNames: {
      monthly: "レポート毎",
      yearly: "年間プラン"
    },
    planFeatures: {
      monthly: ["脆弱性スキャン", "標準レポート", "メールサポート"],
      yearly: ["月次脆弱性スキャン", "詳細レポート", "優先サポート"]
    },
    
    // Modal texts
    requestAdditionalReport: "追加レポートをリクエスト",
    yourCurrentSubscription: "現在のサブスクリプション状況",
    subscriptionStatus: "サブスクリプション状況",
    nextScheduled: "次回予定",
    active: "アクティブ",
    oneTimePayment: "一回払い",
    immediateScanInitiation: "即座にスキャンを開始",
    reportDeliveredWithin1Hour: "1時間以内にレポートを配信",
    separateFromMonthlySchedule: "月次スケジュールとは別",
    cancel: "キャンセル",
    purchaseAdditionalReport: "追加レポートを購入",
    
    // Additional popup texts
    reportGenerationTakingLonger: "レポート生成に時間がかかっています",
    reportGenerationMessage: "予想より時間がかかっています。レポートは以下に送信されます：",
    reportGenerationClose: "このウィンドウを安全に閉じることができます。レポートの準備ができたらメールでお知らせします。",
    close: "閉じる",
    
    // Additional report popup
    additionalReportDescription: "あなたの月次レポートは、スケジュールされた日付で自動的に配信を継続します。これは、通常の月次配信スケジュールに影響を与えずに、今すぐ更新されたレポートを取得できる、別個の即時スキャンです。",
    additionalReportFeatures: [
      "即座にスキャンを開始",
      "1時間以内にレポートを配信", 
      "月次スケジュールとは別"
    ],
    
    // Notification modal
    notification: "通知",
    
    // Success modal
    paymentSuccessful: "支払い完了！",
    paymentSuccessMessage: "🎉 支払いが完了しました！ドメイン評価を開始できます。サイバースペースを安全にしましょう！🚀",
    continue: "続行",
    
    // Domain report buttons and labels
    backToAssessment: "評価に戻る",
    downloadFullReport: "完全レポートをダウンロード",
    sslSecured: "SSL保護済み",
    overallRiskScore: "総合リスクスコア",
    
    // Domain report section headers
    dnsRecords: "DNSレコード",
    sslCertificate: "SSL証明書",
    openPorts: "オープンポート",
    httpHeaders: "HTTPヘッダー",
    detectedTechnologiesVulnerabilities: "検出された技術と脆弱性",
    
    // Port status labels
    open: "オープン",
    closed: "クローズ",
    openLabel: "オープン",
    
    // DNS validation
    dnsValid: "DNS有効",
    
    // Domain report labels
    domainRank: "ドメインランク",
    adultContent: "アダルトコンテンツ",
    parking: "パーキング",
    riskyTld: "リスクTLD",
    
    // Loading states
    verifyingToken: "トークンを認証中...",
    reportGenerationLonger: "レポート生成に時間がかかっています",
    reportGenerationMessage: "予想より時間がかかっています。レポートは以下に送信されます：",
    reportGenerationClose: "このウィンドウを安全に閉じることができます。レポートの準備ができたらメールでお知らせします。",
    
    // Footer
    poweredBy: "搭載",
    
    // Logo alt text
    almataLogo: "Cyber Risk Reportロゴ",
    almataCybersecurity: "Almata Cybersecurity",
    
    // Error messages
    serverError: "サーバーエラー",
    failedToFetchPlans: "プランの取得に失敗しました",
    incompletePlansData: "プランデータが不完全です",
    failedToInitializePayment: "支払いの初期化に失敗しました",
    anErrorOccurred: "エラーが発生しました",
    
    // Token verification
    emailVerifiedSuccess: "メールが正常に認証されました。レポートスキャンのボタンをクリックしてください",
    invalidOrExpiredVerificationToken: "無効または期限切れの認証トークンです。新しいものをリクエストしてください。",
    noOemIdProvided: "スキャンできるOEMパートナーがありません。",
    invalidToken: "無効なトークン",
    verificationEmailSent: "認証メールが送信されました！受信トレイを確認してください。",
    
    // Assessment messages
    assessmentStarted: "評価が開始されました！",
    monthlyPlanMessage: "現在、Almata Globalの12ヶ月サイバーリスク保護プランにサブスクライブしています。詳細なサイバーリスクレポートは自動的に生成され、各サイクルで登録されたメールアドレスに配信されます — あなたの側でアクションは必要ありません。",
    yearlyPlanMessage: "12ヶ月プラン",
    requestAdditionalReportFlag: "追加レポートをリクエスト",
    
    // Backend response messages
    reportCompilationMessage: "サイバーリスクレポートは30分以内にコンパイルされ、登録されたメールアドレスに送信されます",
    
    // Processing states
    processing: "処理中...",
    
    // Plan types
    monthlySubscriber: "月次購読者",
    annualSubscriber: "年間購読者",
    
    // Subscription description
    subscriptionDescription: "あなたは{planType}サブスクリプションを持っており、{reportType}レポートを含んでいます。次回の定期的なスケジュールレポートは{date}に自動的に生成されます。",
    monthlyReports: "12ヶ月",
    regularReports: "定期的",
    
    // Currency and payment
    usd: "USD",
    jpy: "JPY",
    usdLower: "usd",
    jpyLower: "jpy",
    
    // Time intervals
    monthly: "月次",
    annual: "年間",
    oneTime: "一回",
    year: "年",
    one_time: "一回",
    
    // Plan types for comparison
    monthlySubscriberText: "月次購読者",
    annualSubscriberText: "年間購読者",
    
    // Error messages for Stripe components
    failedToConfirmPayment: "Failed to confirm payment",
    errorConfirmingPayment: "Error confirming payment",
    errorDuringPayment: "An error occurred during payment",
    
    // Error messages
    failedToFetchPlans: "プランの取得に失敗しました",
    incompletePlansData: "プランデータが不完全です",
    planDataIncomplete: "Plan data is incomplete",
    selectedPlanDataIncomplete: "Selected plan data is incomplete",
    invalidToken: "無効なトークン",
    
    // Loading and status messages
    verifyingToken: "トークンを認証中...",
    
    // Network status messages
    noInternetConnection: "インターネット接続なし",
    offlineMessage: "オフラインです。インターネットに再接続して再試行してください。",
    retryRefresh: "再試行（ページを更新）",
    waitingForConnection: "接続が戻るのを待っています...",
    offlineNote: "オフライン中は、Stripeなどの外部スクリプトの読み込みに失敗する場合があります。",
    
    // Terms of Service
    termsOfService: "利用規約",
    cyberRiskReport: "外部サイバーリスク評価サービス",
    
    // Section 1: Overview
    overview: "概要",
    overviewText1: "本外部サイバーリスク評価レポートは、指定された完全修飾ドメイン名（FQDN）に関連する、公開されているデジタル上の露出状況を評価するための、自動化された外部評価サービスを提供します。",
    overviewText2: "本サービスは、公開情報および外部からの調査手法のみに基づき、構造化されたサイバーリスクレポートを提供します。",
    overviewText3: "本サービスは、内部システムへのアクセス、認証の回避、または侵入的なテストを行うものではありません。",
    
    // Section 2: Diagnostic Target
    diagnosticTarget: "診断対象",
    singleDomainScope: "2.1 単一ドメインの範囲",
    diagnosticText1: "標準レポートは、以下を対象とします：",
    diagnosticItem1: "1つの完全修飾ドメイン名（FQDN）",
    diagnosticItem2: "当該ドメインに関連する外部公開のインターネット接続インフラ",
    diagnosticText2: "本サービスは以下を含みません：",
    diagnosticNotItem1: "単一のウェブページやURLパスに限定した評価",
    diagnosticNotItem2: "ウェブアプリケーションのペネトレーションテスト",
    diagnosticNotItem3: "脆弱性の悪用を目的とした検証",
    diagnosticNotItem4: "内部ネットワークスキャン",
    diagnosticText3: "本評価は、ドメイン単位の外部評価です。",
    
    // Section 3: Subdomains
    subdomains: "サブドメイン",
    subdomainsText1: "評価プロセスの一環として：",
    subdomainsItem1: "公開情報から確認可能なサブドメインを特定する場合があります",
    subdomainsItem2: "サブドメインは、攻撃対象領域（アタックサーフェス）の可視化および注意喚起目的で一覧表示されます",
    subdomainsText2: "ただし：",
    subdomainsNotItem1: "各サブドメインが自動的に個別スキャンされるものではありません",
    subdomainsNotItem2: "各サブドメインの詳細評価を希望する場合は、個別レポートが必要となります",
    subdomainsText3: "本方式は、評価範囲およびコストの予測可能性を確保するために採用されています。",
    
    // Section 4: Assessment Methodology
    assessmentMethodology: "評価手法",
    methodologyText1: "本サービスでは、以下を自動的に評価する場合があります：",
    methodologyItem1: "DNS設定",
    methodologyItem2: "メールサーバーのセキュリティ設定（SPF、DKIM、DMARC）",
    methodologyItem3: "SSL/TLS証明書の有効性および構成",
    methodologyItem4: "公開された情報漏えい指標",
    methodologyItem5: "公開ポートの露出状況（非侵入型）",
    methodologyItem6: "公開データベースに基づく既知の脆弱性指標",
    methodologyItem7: "技術スタックの識別",
    methodologyItem8: "外部設定の適切性",
    methodologyItem9: "公開レピュテーション情報",
    methodologyItem10: "ドメインメタデータおよびWHOIS情報（法的に取得可能な範囲）",
    methodologyText2: "本サービスは、受動的かつ公開されている情報源に基づきます。",
    methodologyText3: "脆弱性の悪用や認証回避技術は使用しません。",
    
    // Section 5: Risk Scoring
    riskScoring: "リスクスコア",
    riskScoringText1: "各レポートには以下が含まれます：",
    riskScoringItem1: "構造化されたリスクスコア",
    riskScoringItem2: "分類された検出結果",
    riskScoringItem3: "重大度指標",
    riskScoringItem4: "エグゼクティブサマリー",
    riskScoringItem5: "技術的所見",
    riskScoringItem6: "実行可能な改善提案",
    riskScoringText2: "リスクスコアは、独自の評価ロジックおよび自動分析モデルに基づいて算出されます。",
    riskScoringText3: "当該スコアは参考指標であり、認証や保証を意味するものではありません。",
    
    // Section 6: What the Service Does Not Include
    serviceNotInclude: "本サービスに含まれない事項",
    notIncludeText1: "本サービスには以下は含まれません：",
    notIncludeItem1: "ペネトレーションテスト",
    notIncludeItem2: "ソーシャルエンジニアリング",
    notIncludeItem3: "フィッシングシミュレーション",
    notIncludeItem4: "内部ネットワークスキャン",
    notIncludeItem5: "エンドポイントテスト",
    notIncludeItem6: "認証済みアプリケーション層テスト",
    notIncludeItem7: "ソースコードレビュー",
    notIncludeItem8: "規制遵守認証",
    notIncludeItem9: "法的意見の提供",
    notIncludeText2: "追加サービスは、別途契約が必要となる場合があります。",
    
    // Section 7: Data Sources
    dataSources: "データソース",
    dataSourcesText1: "本サービスでは以下を利用する場合があります：",
    dataSourcesItem1: "公開されているインターネット情報",
    dataSourcesItem2: "オープンソースインテリジェンス（OSINT）",
    dataSourcesItem3: "公開脆弱性データベース",
    dataSourcesItem4: "公開漏えいデータセット",
    dataSourcesItem5: "証明書透明性ログ",
    dataSourcesItem6: "DNSおよびメール設定記録",
    dataSourcesText2: "正確性は、これら情報源の可用性および信頼性に依存します。",
    
    // Section 8: Deliverables
    deliverables: "成果物",
    deliverablesText1: "標準成果物には以下が含まれます：",
    deliverablesItem1: "ダウンロード可能なPDF形式のサイバーリスクレポート",
    deliverablesItem2: "経営層向けサマリー",
    deliverablesItem3: "技術的検出結果",
    deliverablesItem4: "推奨改善策",
    deliverablesText2: "サブスクリプションプランに応じて、以下が含まれる場合があります：",
    deliverablesItem5: "履歴トラッキング",
    deliverablesItem6: "月次モニタリング",
    deliverablesItem7: "リスク傾向の可視化",
    deliverablesItem8: "ライセンスキーによるレポートアクセス",
    deliverablesItem9: "ドメインの再スキャン",
    
    // Section 9: Customer Responsibilities
    customerResponsibilities: "お客様の責任",
    customerRespText1: "お客様は以下について責任を負います：",
    customerRespItem1: "提出ドメインに対する評価権限の確保",
    customerRespItem2: "検出結果の確認",
    customerRespItem3: "推奨改善策の実施",
    customerRespItem4: "自社のサイバーセキュリティ体制の維持",
    customerRespText2: "本サービスは助言的性質のものです。",
    
    // Section 10: Service Limitations
    serviceLimitations: "サービスの制限",
    limitationsText1: "本評価は外部かつ非侵入型であるため：",
    limitationsItem1: "一部の脆弱性は検出できない場合があります",
    limitationsItem2: "結果は時間経過とともに変化する場合があります",
    limitationsItem3: "新たに発見された脆弱性が即時反映されない場合があります",
    limitationsItem4: "公開データに誤りが含まれる可能性があります",
    limitationsText2: "本サービスは、評価実施時点における外部可視リスクのスナップショットを提供するものです。",
    
    // Section 11: Service Availability
    serviceAvailability: "サービス提供条件",
    availabilityText1: "本サービスは、自動化されたベストエフォート方式で提供されます。",
    availabilityText2: "以下を保証するものではありません：",
    availabilityItem1: "継続的なサービス提供",
    availabilityItem2: "リアルタイムの脅威検知",
    availabilityItem3: "常時即時のレポート生成",
    availabilityText3: "メンテナンス期間が発生する場合があります。",
    
    // Domain Report
    noDataReceived: "APIからデータを受信できませんでした",
    failedToLoadReport: "レポートデータの読み込みに失敗しました",
    reportPdf: "レポート.pdf",
    loading: "読み込み中...",
    loadingSecurityReport: "セキュリティレポートを読み込み中...",
    backToHome: "ホームに戻る",
    domainSecurityReport: "ドメインセキュリティレポート",
    noSummaryAvailable: "サマリーが利用できません。",
    domain: "ドメイン",
    ipAddress: "IPアドレス",
    networkPerformance: "ネットワークパフォーマンス",
    server: "サーバー",
    rootDomain: "ルートドメイン",
    city: "都市",
    region: "地域",
    country: "国",
    countryCode: "国コード",
    isp: "ISP（インターネットサービスプロバイダー）",
    latitude: "緯度",
    longitude: "経度",
    timezone: "タイムゾーン",
    zip: "郵便番号",
    dnssec: "DNSSEC",
    registrar: "レジストラ",
    registrarUrl: "レジストラURL",
    signed: "署名済み",
    unsigned: "未署名",
    na: "N/A",
    
    // Additional Domain Report fields
    registrantCountry: "登録者国",
    registrantStateProvince: "登録者州/県",
    registrantEmail: "登録者メール",
    nameServers: "ネームサーバー",
    registrarAbuseContact: "レジストラ不正使用連絡先",
    registrarWhoisServer: "レジストラWHOISサーバー",
    
    // Coupon functionality
    couponCode: "クーポンコード",
    couponCodePlaceholder: "クーポンコードを入力",
    applyCoupon: "クーポンを適用",
    couponApplied: "クーポンが正常に適用されました！",
    couponInvalid: "無効なクーポンコード",
    couponInvalidForPlan: "このプランではクーポンが無効です",
    couponExpired: "クーポンの有効期限が切れています",
    couponAlreadyUsed: "クーポンは既に使用されています",
    discountApplied: "割引が適用されました",
    originalPrice: "元の価格",
    discountedPrice: "割引価格",
    removeCoupon: "クーポンを削除",
    
    // Additional status messages and labels
    success: "成功！",
    errorLoadingReport: "レポートの読み込みエラー",
    noReportDataAvailable: "レポートデータが利用できません",
    expired: "期限切れ",
    unknown: "不明",
    listed: "リスト化",
    clean: "クリーン",
    present: "存在",
    notPresent: "存在しない",
    detected: "検出",
    notDetected: "未検出",
    highRisk: "高リスク",
    lowRisk: "低リスク",
    valid: "有効",
    invalid: "無効",
    none: "なし",
    yes: "はい",
    no: "いいえ",
    scanId: "スキャンID",
    noBreachesFound: "侵害は検出されませんでした",
    switchToEnglish: "英語に切り替え",
    switchToJapanese: "日本語に切り替え",
    breachDetected: "侵害が検出されました",
    pleaseSubmitDomainFirst: "最初にドメインを評価用に送信してください",
    packetLoss: "パケットロス",
    rtt: "RTT",
    exploitability: "悪用可能性",
    impact: "影響",
    baseScore: "基本スコア",
    copyrightText: "株式会社 全著作権所有。"
  }
};
